import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { updateLoader } from "../../../_redux/LoaderSlice";
import * as _ser from "../../../_redux/_services/ApplicantsSlice";
import * as _postingsser from "../../../_redux/_services/JobPostingSlice";
import {
  getAttributes,
  getUserDetails,
  GetUserId,
  GetUserInfo,
} from "../../../_utilities/getUserInfo";
import ApplicantsComponent from "../ApplicantsComponent";
import ApplicantsManualUploadPopup from "../ApplicantsTable/ApplicantsManualUploadPopup";
import DuplicateApplicantsManualUploadPopup from "../ApplicantsTable/DuplicateApplicantsManualUploadPopup";
import "./ApplicantsCreate.css";
import { customFieldsAsync } from "../../../_redux/_services/UserManagerSlice";
import Cookies from "js-cookie";
import { setSelectedJobPosting } from "../../../_redux/SelectedJobPostingSlice";

const initalState = {
  data: null,
  message: "",
  isloader: true,
  manualDuplicateApplicant: null,
};

const getJobPostingPath = () => {
  return (
    Cookies.get("jobPostingViewPreference") || "/ats/layout/jobpostings/landing"
  );
};

const ApplicantsCreate = () => {
  const [inputData, setInputData] = useState(undefined);
  const [isUpload, setIsUpload] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [actionButtons, setActionButtons] = useState(
    JSON.parse(JSON.stringify(actionBtns)),
  );
  const [uploadFile, setUploadFile] = useState();
  const [applicantFile, setApplicantFile] = useState(null);
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(false);
  const [userId, setUserId] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [duplicateApplicatsConfirmPopup, setDuplicateApplicatsConfirmPopup] =
    useState(false);
  const [skipId, setSkipId] = useState(null);
  const [skipName, setSkipName] = useState(null);
  const [
    twoDuplicateApplicatsConfirmPopup,
    setTwoDuplicateApplicatsConfirmPopup,
  ] = useState(false);

  const uploadResumeData = useSelector((store) => store.UploadResume.data);

  const DuplicateResume = useSelector((store) => store.DuplicateResume.data);
  const UploadDocCode = useSelector((state) => state.UploadDocuments.data);

  const selectedJobDetails = useSelector(
    (state) => state.SetSelectedJobDetails.data,
  );

  useEffect(() => {
    if (
      location.state &&
      location.state?.applicant &&
      location.state?.sourceId &&
      location.state?.uploadfile
    ) {
      setIsUpload(false);
      let json = JSON.parse(JSON.stringify(location.state.applicant));
      json.Applicants["resumesourceId"] = location.state.sourceId.id;
      json.Applicants["resumesource"] = location.state.sourceId.name;
      json.Applicants["candidateStatus"] = location.state.candidateStatus;
      json["Resume"] = location.state.uploadfile;
      setApplicantFile(location.state.uploadfile);
      getRenderUI(json);
    }
  }, [location]);

  useEffect(() => {
    if (
      location.state &&
      location.state?.isAssociate !== null &&
      location.state?.showLandingPage !== true &&
      !isManualCreate && location.state?.isAssociate?.jobId !== 0
    ) {
      let array = JSON.parse(JSON.stringify(actionBtns));
      dispatch(_ser.setSelectedJobDetailsStartReducer(initalState));
      const jobId =
        location.state?.isAssociate?.jobId || location.state?.isAssociate;
        setActionButtons(array);
      if (getJobPostingPath().includes('jobpostings/list')) {
        dispatch(setSelectedJobPosting({ storedJobPostingId: jobId }));
        array[0].navigateTo = `/ats/layout/jobpostings/list/landing?tab=associatedapplicants`;
        
      } else {
        array[0].navigateTo = `/ats/layout/jobpostings/view/${jobId}?tab=associatedapplicants`;
        // array[0].navigateTo = `/ats/layout/jobpostings/associatedapplicants/${jobId}`;
      }
    } else {
      setActionButtons(JSON.parse(JSON.stringify(actionBtns)));
    }
  }, [location]);

  useEffect(() => {
    async function init() {
      const userId = await GetUserId();
      setUserId(userId);
    }
    init();
  }, []);

  useEffect(() => {
    let path = location.pathname;
    if (path.includes("create-duplicate")) {
      setDisableSubmitBtn(false);
    }
    setDuplicateApplicatsConfirmPopup(false);
  }, [location]);

  useEffect(() => {
    if (uploadResumeData !== null) {
      setIsLoading(false);
      setIsUpload(false);
      dispatch(_ser.uploadResumeStartReducer(initalState));
      let json = JSON.parse(JSON.stringify(uploadResumeData[0]));
      getRenderUI(json);
    }
  }, [uploadResumeData]);

  useEffect(() => {
    const processDuplicateResume = async () => {
      if (DuplicateResume !== null) {
        setDisableSubmitBtn(false);
        // Make async calls safely
        const attribute = await getAttributes();
        const userInfo = await GetUserInfo(); // If this is async
        // If GetUserInfo is not async → remove await

        if (location.state?.associateAnyway === true) {
          dispatch(_ser.addApplicantWithAssocatedStartReducer(initalState));
          let obj = {
            id: DuplicateResume.insertId,
            applicantCode: DuplicateResume.latestapplicantcode,
            portalassociatedApplicants: "associatedApplicants",
            submittedBy: userInfo[0].id,
            source: "ATS",
            firstName: attribute[0].firstName,
            lastName: attribute[0].lastName,
            status: "Associated",
            docId: DuplicateResume.docId,
          };
          dispatch(
            _postingsser.addAssociatedjobsAsync(
              location.state.isAssociate.jobId,
              obj,
            ),
          );
          dispatch(_ser.addApplicantsStartReducer(initalState));
        } else {
          dispatch(_ser.duplicateResumeStartReducer(initalState));
          navigate("/ats/layout/applicants/landing");
        }
      }
    };

    processDuplicateResume();
  }, [DuplicateResume]);

  const getRenderUI = (json) => {
    let obj = json;
    obj.Applicants = json.Applicants;
    obj.Applicants["contactNumber"] = json.Applicants.phone;
    obj.Applicants["alternateContactNumber"] = json.Applicants
      .alternateContactNumber
      ? json.Applicants.alternateContactNumber
      : "";
    obj.Applicants["phone"] = obj.Applicants.phone ? obj.Applicants.phone : "";
    obj.formattedLocation =
      json?.locationData?.formatted ?? json?.formattedLocation ?? "";
    obj.locationRawInput =
      json?.locationData?.locationRawInput ?? json?.locationRawInput ?? "";
    obj.latitude = json?.locationData?.latitude ?? json?.latitude ?? "";
    obj.longitude = json?.locationData?.longitude ?? json?.longitude ?? "";
    obj.locationCity = json?.locationData?.city ?? json?.locationCity ?? "";
    obj.locationCountry =
      json?.locationData?.country ?? json?.locationCountry ?? "";
    obj.locationState = json?.locationData?.state ?? json?.locationState ?? "";
    obj.rawData = json.rawData ? json.rawData : "";
    json.educationDetails &&
      json.educationDetails.forEach((e, i) => {
        e["isEdit"] = false;
        e["id"] = i;
        e["startDate"] = e.startDate
          ? new Date(e.startDate).toLocaleDateString()
          : null;
        e["endDate"] = e.endDate
          ? new Date(e.endDate).toLocaleDateString()
          : null;
        e["duration"] = `${e.startDate} - ${e.endDate}`;
        e["isCurrent"] = false;
        e["location"] =
          e.location && e.location.formatted ? e.location.formatted : "";
        e["location"] = undefined;
      });
    obj.educationDetails =
      json.educationDetails !== undefined ? json.educationDetails : [];
    json.workExperiences &&
      json.workExperiences.forEach((e, i) => {
        e["isEdit"] = false;
        e["id"] = i;
        e["startDate"] =
          e.experienceInMonths && e.experienceInMonths.startDate
            ? new Date(e.experienceInMonths.startDate).toLocaleDateString()
            : null;
        e["endDate"] =
          e.experienceInMonths && e.experienceInMonths.endDate
            ? new Date(e.experienceInMonths.endDate).toLocaleDateString()
            : null;
        e["duration"] = `${e.startDate} - ${e.endDate}`;
        e["monthsInPosition"] =
          e.experienceInMonths && e.experienceInMonths.monthsInPosition
            ? e.experienceInMonths.monthsInPosition
            : "";
        e["isCurrent"] =
          e.experienceInMonths && e.experienceInMonths.isCurrent
            ? e.experienceInMonths.isCurrent
            : false;
        e["rawText"] =
          e.experienceInMonths && e.experienceInMonths.rawText
            ? e.experienceInMonths.rawText
            : "";
        e["experienceInMonths"] = undefined;
      });
    obj["workExp"] =
      json.workExperiences !== undefined ? json.workExperiences : [];
    obj.skillDetails = json.skillDetails;
    obj["certification"] = json.certifications || [];
    obj.totalExperience = json.totalExperience;
    obj.linkedIn = json.linkedIn ?? "";
    obj.jobDescription = json.jobDescription ? json.jobDescription : "";
    obj.source = json.source ? json.source : "ATS";
    obj.Applicants.candidateStatus = json.Applicants.candidateStatus
      ? json.Applicants.candidateStatus
      : "";
    setInputData(obj);
    dispatch(_ser.uploadResumeStartReducer(initalState));
  };

  const Applicantdata = useSelector((store) => store.AddApplicants.data);
  const Applicantcode = useSelector((store) => store.AddApplicants.code);

  const { code, data } = useSelector(
    (store) => store.AddApplicantWithAssocated,
  );

  const ManualDuplicateResume = useSelector(
    (store) => store.AddApplicants.manualDuplicateApplicant,
  );

  const AllowDuplicateResume = useSelector(
    (store) => store.AddApplicants.updatedata,
  );
  const isManualCreate = location.state?.createManually === true;

  // Build rawData from all values in updateData
  const buildRawData = (data) => {
    const out = [];

    const walk = (val) => {
      if (val == null) return;

      if (
        typeof val === "string" ||
        typeof val === "number" ||
        typeof val === "boolean"
      ) {
        const v = String(val).trim();
        if (v) out.push(v);
      } else if (Array.isArray(val)) {
        val.forEach(walk);
      } else if (typeof val === "object") {
        Object.values(val).forEach(walk);
      }
    };

    walk(data);
    return out.join(" ");
  };

  const GetValidData = async (updateData) => {
    const userData = await GetUserInfo();
    const userInfo = await getUserDetails();
    let formData = new FormData();
    formData.append("firstName", updateData.Applicants.firstName);
    formData.append("lastName", updateData.Applicants.lastName);
    formData.append("contactNumber", updateData.Applicants.contactNumber);
    formData.append(
      "alternateContactNumber",
      updateData.Applicants.alternateContactNumber,
      // ? updateData.Applicants.alternateContactNumber : updateData.Applicants.phone ? updateData.Applicants.phone : ""
    );
    formData.append("emailId", updateData.Applicants.emailId);
    formData.append(
      "educationDetails",
      JSON.stringify(
        updateData.educationDetails ? updateData.educationDetails : [],
      ),
    );
    formData.append(
      "workExp",
      JSON.stringify(updateData.workExp ? updateData.workExp : []),
    );
    formData.append(
      "certification",
      JSON.stringify(updateData.certification ? updateData.certification : []),
    );
    formData.append(
      "skillDetails",
      JSON.stringify(updateData.skillDetails ? updateData.skillDetails : []),
    );
    formData.append(
      "jobTitle",
      updateData.workExp && updateData.workExp.length > 0
        ? updateData.workExp[updateData.workExp.length - 1].jobTitle
        : "",
    );
    formData.append("jobDescription", updateData.jobDescription);
    if (
      (updateData?.applicantFiles &&
        Object.keys(updateData?.applicantFiles)?.length > 0) ||
      applicantFile !== null
    ) {
      formData.append(
        "Resume",
        updateData.applicantFiles &&
          Object.keys(updateData.applicantFiles).length > 0
          ? updateData.applicantFiles
          : applicantFile,
      );
    }
    formData.append("customFields", updateData.customFields);
    formData.append("userId", userInfo.userId);
    formData.append("userFirstName", userInfo.firstName);
    formData.append("userLastName", userInfo.lastName);
    formData.append(
      "identifier",
      updateData.identifier
        ? updateData.identifier
        : updateData.oldidentifier_f,
    );
    formData.append("customerId", userId);
    formData.append("source", "ATS");
    formData.append("DbUserId", userInfo?.id);
    formData.append("resumesourceId", updateData.Applicants.resumesourceId);
    formData.append("resumesource", updateData.Applicants.resumesource);
    formData.append("candidateStatus", updateData.Applicants.candidateStatus);
    formData.append("totalExperience", updateData.totalExperience);
    formData.append("linkedIn", updateData?.linkedIn ?? "");
    formData.append(
      "formattedLocation",
      updateData?.formattedLocation ?? "", // updateData?.locationData?.formatted ??
    );
    formData.append(
      "locationRawInput",
      updateData?.locationRawInput ?? updateData?.locationData?.locationRawInput ?? "",
    );
    formData.append(
      "latitude",
      updateData?.latitude ?? "", // updateData?.locationData?.latitude ??
    );
    if (!isManualCreate) {
      formData.append("rawData", updateData?.rawData ?? "");
    }
    formData.append(
      "longitude",
      updateData?.longitude ?? "", // updateData?.locationData?.longitude ??
    );
    formData.append(
      "locationCity",
      updateData?.locationCity ?? "", // updateData?.locationData?.city ??
    );
    formData.append(
      "locationCountry",
      updateData?.locationCountry ?? "", // updateData?.locationData?.country ??
    );
    formData.append(
      "locationState",
      updateData?.locationState ?? "", // updateData?.locationData?.state ??
    );
    if (isManualCreate) {
      formData.append("isManual", 1);
    }
    setInputData(updateData);
    setDisableSubmitBtn(false);
    if (location?.state?.isduplicate === true) {
      setDuplicateApplicatsConfirmPopup(false);
      dispatch(_ser.duplicateResumeAsync(formData, true));
    } else if (location?.state && location.state.isAssociate !== null && location.state?.isAssociate?.jobId !== 0) {
      if (
        data !== null &&
        data.message.includes(
          "Applicant Already Exists In Parsed DB With Identifier:",
        )
      ) {
      } else {
        if (location.state.isManual === true) {
          dispatch(_ser.addApplicantsAsync(formData, true));
        } else if (isManualCreate) {
          const rawData = buildRawData(updateData);
          formData.append("rawData", rawData);
          dispatch(_ser.addApplicantsAsync(formData, true));
        } else {
          formData.append("primaryResume", 1);
          dispatch(
            _ser.addApplicantWithAssocatedAsync(
              formData,
              location.state.isAssociate.jobId,
              true,
            ),
          );
        }
      }
    } else {
      formData.append("primaryResume", 1);
      dispatch(_ser.addApplicantsAsync(formData, true));
    }
  };

  useEffect(() => {
    async function processApplicantData() {
      if (Applicantcode === 200 || Applicantcode === 500) {
        if (
          location.state &&
          location.state.isAssociate === null &&
          location.state.isManual === false
        ) {
          setDisableSubmitBtn(false);
          dispatch(_ser.addApplicantsStartReducer(initalState));
          navigate("/ats/layout/applicants/landing");
        } else if (
          Applicantdata !== null &&
          Applicantdata.jobCode &&
          location.state.isManual === false
        ) {
          setDisableSubmitBtn(false);
          dispatch(_ser.addApplicantWithAssocatedStartReducer(initalState));
          let attribute = await getAttributes();
          let userInfo = await GetUserInfo();
          let obj = {
            id: Applicantdata.insertedid,
            jobCode: Applicantdata.jobCode,
            applicantCode: Applicantdata.latestapplicantcode,
            portalassociatedApplicants: "associatedApplicants",
            submittedBy: userInfo[0].id,
            source: "ATS",
            firstName: attribute[0].firstName,
            lastName: attribute["0"].lastName,
            status: "Associated",
            docId: Applicantdata.docId,
          };
          dispatch(
            _postingsser.addAssociatedjobsAsync(
              location.state.isAssociate.jobId
                ? location.state.isAssociate.jobId
                : location.state.isAssociate,
              obj,
            ),
          ); ///  location.state.isAssociate.jobId
          dispatch(_ser.addApplicantsStartReducer(initalState));
        } else if (
          location.state.isManual && // came from "Create Manually"
          location.state?.isAssociate && // we have job info in state
          Applicantdata !== null && // applicant is created
          !Applicantdata.jobCode
        ) {
          setDisableSubmitBtn(false);

          const userAttr = await getAttributes();
          const userInfo = await GetUserInfo();

          const obj = {
            id: Applicantdata.insertedid ?? Applicantdata.insertId,
            jobCode: location.state.isAssociate.jobCode, // use jobCode from state
            applicantCode: Applicantdata.latestapplicantcode,
            portalassociatedApplicants: "associatedApplicants",
            submittedBy: userInfo[0].id,
            source: "ATS",
            firstName: userAttr[0].firstName,
            lastName: userAttr[0].lastName,
            status: "Associated",
            docId: Applicantdata.docId ?? null,
          };

          dispatch(
            _postingsser.addAssociatedjobsAsync(
              location.state.isAssociate.jobId,
              obj,
            ),
          );

          dispatch(_ser.addApplicantsStartReducer(initalState));
        } else if (Applicantdata !== null && Applicantdata.jobCode === "") {
          setDisableSubmitBtn(false);
          dispatch(_ser.addApplicantsStartReducer(initalState));
          navigate("/ats/layout/applicants/landing");
        }
      }
    }
    processApplicantData();
  }, [Applicantcode, Applicantdata]);

  useEffect(() => {
    if (AllowDuplicateResume !== null) {
      setDuplicateApplicatsConfirmPopup(true);
      setSkipId(AllowDuplicateResume.id);
      setDisableSubmitBtn(false);
    }
  }, [AllowDuplicateResume]);

  useEffect(() => {
    if (ManualDuplicateResume) {
      setTwoDuplicateApplicatsConfirmPopup(true);
      setSkipId(ManualDuplicateResume.id);
      setSkipName(ManualDuplicateResume.fullName);
      setDisableSubmitBtn(false);
      dispatch(_ser.addApplicantsStartReducer(initalState));
    }
  }, [ManualDuplicateResume]);

  useEffect(() => {
    async function processAssociatedApplicants() {
      if (code === 200) {
        setDisableSubmitBtn(false);
        dispatch(_ser.addApplicantWithAssocatedStartReducer(initalState));
        let attribute = await getAttributes();
        let userInfo = await GetUserInfo();
        let obj = {
          id: data.insertedid,
          jobCode: data.jobCode,
          applicantCode: data.latestapplicantcode,
          portalassociatedApplicants: "associatedApplicants",
          submittedBy: userInfo[0].id,
          source: "ATS",
          firstName: attribute[0].firstName,
          lastName: attribute[0].lastName,
          status: "Associated",
          docId: data.documentId,
        };
        let jobs = [];
        if (selectedJobDetails && selectedJobDetails.length > 0) {
          selectedJobDetails.forEach((job) => {
            let object = {};
            object["jobId"] = job.id;
            object["jobCode"] = job.jobCode;
            jobs.push(object);
          });
        }
        obj["jobs"] =
          jobs.length > 0
            ? jobs
            : [
                {
                  jobId: location.state.isAssociate.jobId,
                  jobCode: data.jobCode,
                },
              ];
        dispatch(
          _ser.addAssociatedjobsAsync(location.state.isAssociate.jobId, obj),
        );
      }
    }
    processAssociatedApplicants();
  }, [code, data]);

  const AddAssociatedjobscode = useSelector(
    (state) => state.AddAssociatedjobs.data,
  );

  useEffect(() => {
    if (AddAssociatedjobscode === 200) {
      dispatch(updateLoader(false));
      dispatch(_ser.setSelectedJobDetailsStartReducer(initalState));
      const jobId =
        location.state?.isAssociate?.jobId || location.state?.isAssociate;
      if (getJobPostingPath().includes('jobpostings/list')) {
        dispatch(setSelectedJobPosting({ storedJobPostingId: jobId }));
        navigate(`/ats/layout/jobpostings/list/landing?tab=associatedapplicants`);
      } else {
        navigate(`/ats/layout/jobpostings/view/${jobId}?tab=associatedapplicants`);
        // navigate(`/ats/layout/jobpostings/associatedapplicants/${jobId}`);
      }
      dispatch(_ser.addAssociatedjobsStartReducer(initalState));
    }
  }, [AddAssociatedjobscode]);

  useEffect(() => {
    console.log("isUpload", isUpload);
    console.log("isLoading", isLoading);
  }, [isUpload, isLoading]);

  useEffect(() => {
    if (UploadDocCode === 200) {
      navigate(`/ats/layout/applicants/documents/${skipId}`);
      dispatch(_ser.uploadDocumentsStartReducer(initalState));
    }
  }, [UploadDocCode]);

  return (
    <>
      <ApplicantsComponent
        componentType="Create"
        input={inputData}
        iniValue={initialDetails}
        actions={actionButtons}
        onValidData={GetValidData}
        disableSubmitBtn={disableSubmitBtn}
      />

      {duplicateApplicatsConfirmPopup === true && (
        <ApplicantsManualUploadPopup
          skipId={skipId} // comes from service id
          isAssociatedApplicant={location.state.associateAnyway}
          updateProfileWithNewResume={inputData}
          sourceId={inputData.resumesourceId}
          defaultFile={applicantFile}
          applicantCode={AllowDuplicateResume.applicantCode}
          setDuplicateApplicatsConfirmPopup={(e) => {
            setDuplicateApplicatsConfirmPopup(e);
          }}
        />
      )}

      {twoDuplicateApplicatsConfirmPopup === true && (
        <DuplicateApplicantsManualUploadPopup
          skipId={skipId}
          skipName={skipName}
          setTwoDuplicateApplicatsConfirmPopup={() => {
            setTwoDuplicateApplicatsConfirmPopup(false);
            dispatch(_ser.addApplicantsStartReducer(initalState));
            dispatch(customFieldsAsync(userId));
            setSkipId(null);
            setSkipName(null);
            setInputData(initialDetails);
          }}
        />
      )}
    </>
  );
};

export default ApplicantsCreate;

const initialDetails = {
  Applicants: {
    firstName: "",
    lastName: "",
    contactNumber: "",
    alternateContactNumber: "",
    emailId: "",
  },
  educationDetails: [
    { id: "", education: "", startDate: null, endDate: null, location: "" },
  ],
  workExp: [
    {
      id: "",
      organization: "",
      jobTitle: "",
      industry: "",
      startDate: null,
      endDate: null,
      isCurrent: "",
      location: "",
      jobDescription: "",
    },
  ],
  formatted: null,
  rawInput: null,
  latitude: null,
  longitude: null,
  city: null,
  country: null,
  state: null,
  skillDetails: [],
  certification: [],
  customFields: "",
  totalExperience: null,
  linkedIn: "",
  id: 0,
  userId: "",
  firstName: "",
  lastName: "",
  identifier: "",
  customerId: 0,
  source: "ATS",
  resumesourceId: "",
  candidateStatus: "",
  rawData: "",
};

const actionBtns = [
  {
    variant: "text",
    style: { color: "red", marginRight: "25px", fontWeight: "bolder" },
    navigateTo: "/ats/layout/applicants/landing",
    label: "Cancel",
    type: "back",
    class: "buttonHover",
  },
  {
    variant: "contained",
    style: {
      backgroundColor: "var(--primary-bg-color)",
      color: "var(--primary-background-text-color)",
      borderRadius: "10px",
      width: "6rem",
      fontSize: "14px",
    },
    navigateTo: null,
    label: "Save",
    type: "submit",
    class: "buttonHover1",
  },
];
